import React from "react";

export default function WorkflowSelector({ workflows, activeIndex, onSelect }) {
  return (
    <div className="lcx-cards">
      {workflows.map((wf, i) => (
        <button
          key={wf.id}
          type="button"
          className={`lcx-card ${activeIndex === i ? "active" : ""}`}
          onClick={() => onSelect(i)}
        >
          {activeIndex === i && <span className="active-badge">ACTIVE</span>}
          <span className="icon">{wf.icon}</span>
          <div className="name">{wf.name}</div>
          <div className="desc">{wf.desc}</div>
          <div className="tags">
            {wf.regs.map((r) => <span key={r} className="tag">{r}</span>)}
          </div>
          <div className="meta">
            {wf.docId} · Time saved: {wf.timeSaved}
            {wf.extraStat ? ` · ${wf.extraStat}` : ""}
          </div>
        </button>
      ))}
    </div>
  );
}